import { UserRepository } from './user-repository';

export class UserMockRepository implements UserRepository {
	public setTokenClaims(userId: string, accessToken: string): Promise<void> {
		return Promise.resolve();
	}
}
